import { SettingsConstants } from '../../constants'

const objFunc = () => {
  return {
    paymentCards: [],
    validations: {
      payment: {},
      disburse: {
        maxCardLimit: SettingsConstants.maxDisburseCardLimit
      }
    },
    bridgePayToken: undefined,
    tokenPayInstance: undefined,
    repayTokenInfo: undefined
  }
}

export default objFunc()

export const defaultObj = objFunc()
